import { AnyFieldMeta } from '@tanstack/react-form';

export const FieldInfo = ({ fieldMeta }: { fieldMeta: AnyFieldMeta }) => {
  return (
    <>
      {fieldMeta && fieldMeta.isTouched && fieldMeta.errors?.length ? (
        <p className="text-xs text-red-500">{fieldMeta.errors.join(', ')}</p>
      ) : null}
      {/* {fieldMeta && fieldMeta.isValidating ? 'Validating...' : null} */}
    </>
  );
};
